import { ValidationError } from "sequelize"
import {
    MtTaskComment,
    MtTaskCommentCreate,
    MtTaskCommentSave,
    MtTaskCommentAttachment,
    MtDriveFile,
    SaveMtTaskCommentAttachmentType,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import { LangType } from "client/store"
import { TaskCommentValidation } from "./types"


export const LoadAllTaskComments = (taskId: number) => (
    GET(`/mtTaskComment/taskId/${taskId}`)
    .then((comments: MtTaskComment[]) => comments)
)

export const LoadTaskCommentById = (commentId: number) => (
    GET(`/mtTaskComment/id/${commentId}`)
    .then((comment: MtTaskComment) => comment)
)

export const SaveTaskComment = (
    id: number,
    comment: MtTaskCommentCreate,
    attachments: readonly MtDriveFile[],
    lang: LangType,
) => {
    const data: MtTaskCommentSave = {
        id,
        comment,
    }
    return POST(
        "/mtTaskComment/save",
        JSON.stringify(data),
    ).then((res) => {
        const newComment = res as MtTaskComment
        const error = res as ValidationError

        const newCommentId = newComment.id || null
        const validation = <TaskCommentValidation>validate(error, lang)

        if (validation) {
            return {
                newCommentId,
                validation,
            }
        }

        const attachmentData: MtTaskCommentAttachment[] = []
        attachments.forEach((file, index) => {
            attachmentData.push({
                commentId: newCommentId || id,
                fileId: file.id,
                order: index,
            })
        })

        return SaveTaskCommentAttachments(newCommentId || id, attachmentData)
        .then(() => ({
            newCommentId,
            validation,
        }))
    })
}

export const DeleteTaskComment = (
    commentId: number,
    taskId: number,
) => (
    DELETE(`/mtTaskComment/delete/${commentId}/${taskId}`)
    .then((removedRows: number) => removedRows)
)

export const LoadTaskCommentAttachments = (commentId: number) => (
    GET(`/mtTaskCommentAttachment/commentId/${commentId}`)
    .then((attachments: MtTaskCommentAttachment[]) => attachments)
)

export const SaveTaskCommentAttachments = (
    commentId: number,
    attachments: MtTaskCommentAttachment[],
) => {
    const attachmentsData: SaveMtTaskCommentAttachmentType = {
        commentId,
        attachments,
    }
    return POST(
        "/mtTaskCommentAttachment/save",
        JSON.stringify(attachmentsData),
    )
}
